import { jsx } from "react/jsx-runtime";
import originalI81next from "i18next";
import { forwardRef, useContext, useEffect } from "react";
import { I18nContext, I18nextProvider } from "react-i18next";
import { useI18n } from "./hook.js";
import { i18nLibraryInstance } from "./library.js";
const withI18n = /* @__NO_SIDE_EFFECTS__ */ (WrappedComponent) => {
  const ComponentWithI18n = forwardRef(({ currentLanguage, ...props }, ref) => {
    const { i18n, isInitialized } = useI18n(currentLanguage);
    const i18nContext = useContext(I18nContext);
    const parentI18n = i18nContext?.i18n;
    const hasParentProvider = parentI18n?.isInitialized && parentI18n !== i18nLibraryInstance && parentI18n !== originalI81next;
    const hasGlobalInstance = originalI81next?.__serviceI18nGlobalInstance;
    const shouldSkipProvider = hasParentProvider || hasGlobalInstance;
    useEffect(() => {
      if (currentLanguage && isInitialized) {
        i18n.changeLanguage(currentLanguage);
      }
    }, [currentLanguage, isInitialized, i18n]);
    if (!isInitialized) {
      return null;
    }
    if (shouldSkipProvider) {
      return jsx(WrappedComponent, { ref, ...props });
    }
    return jsx(I18nextProvider, { i18n, children: jsx(WrappedComponent, { ref, ...props }) });
  });
  const displayName = WrappedComponent.displayName || WrappedComponent.name || "Component";
  ComponentWithI18n.displayName = `withI18n(${displayName})`;
  return ComponentWithI18n;
};
export {
  withI18n
};
//# sourceMappingURL=components.js.map
